<div class="full-height">
  <pp-common-components [ppFromSite]="true"></pp-common-components>

  <div
    class="site"
    id="site"
    [class.site--no-sidebar]="sidePanel.hidden"
    [class.site--disabled]="isLoadingTable"
  >
    <div
      id="siteHeader"
      data-m-target="Work list menu"
      class="site__header"
      role="heading"
      [class.site__header--disabled]="isLoadingTable"
    >
      <pp-site-options
        class="siteOptionsComponent"
        [ppDataFetched]="dataFetched?.dataFetched"
        [ppIsTableLoading]="isLoadingTable"
      />
    </div>

    <div class="site__body" [class.site__body--hidden]="workspace?.hidden" #body>
      <div
        class="site__table-wrapper"
        [ngStyle]="{
          'width.%': siteElementSizes.sitePlanWidth ? 100 - siteElementSizes.sitePlanWidth : 50,
        }"
        data-m-target="Work list table"
        [class.site__table-wrapper--expanded]="!site.sitePlanVisible && !checkIfPointOpened()"
        [class.site__table-wrapper--hidden]="site.sitePlanVisible && site.sitePlanFullWidth"
      >
        @if (workspaceId && workspace && !processing) {
          <pp-site-table
            [ppWorkspaceId]="workspaceId"
            [ppHidden]="site.sitePlanVisible && site.sitePlanFullWidth"
            [ppFullWidth]="!site.sitePlanVisible"
            [ppHalfWidth]="site.sitePlanVisible || checkIfPointOpened()"
          />
        }

        @if (!tableFetched?.dataFetched || !dataFetched?.dataFetched) {
          <div
            class="site__table-placeholderWrapper"
            [ngStyle]="{
              'width.%': siteElementSizes.sitePlanWidth ? 100 - siteElementSizes.sitePlanWidth : 50,
            }"
            [class.site__table-wrapper--expanded]="!site.sitePlanVisible"
          >
            <pp-site-table-placeholder [ppPlanWidth]="siteElementSizes.sitePlanWidth" />
          </div>
        }
      </div>

      @if (dataFetched) {
        <div
          class="halfPointContainer"
          [class.halfPointContainer--hidden]="!checkIfPointOpened()"
          [ngStyle]="{
            'width.%': siteElementSizes.sitePlanWidth ? siteElementSizes.sitePlanWidth : 50,
          }"
        >
          <router-outlet></router-outlet>
        </div>
      }

      <div
        class="site__site-plan"
        data-testid="site-plan"
        [ngStyle]="{
          'width.%': siteElementSizes.sitePlanWidth ? siteElementSizes.sitePlanWidth : 50,
        }"
        [ngClass]="{ 'site__site-plan--hidden': !site.sitePlanVisible }"
        [class.site__site-plan--full-width]="site.sitePlanVisible && site.sitePlanFullWidth"
      >
        @if (site.sitePlanVisible && !site.sitePlanFullWidth) {
          <pp-column-resizer
            (ppDrag)="onPlanResizerDrag($event)"
            (ppDrop)="onPlanResizerDrop()"
          ></pp-column-resizer>
        }

        @if (dataFetched?.dataFetched && site.sitePlanVisible) {
          <pp-plan
            [ppWidth]="siteElementSizes.sitePlanWidth"
            [ppModule]="EPlanModule.SITE"
            [ppWorkspaceId]="workspaceId"
          ></pp-plan>
        }
      </div>
    </div>

    @if (workspace?.hidden) {
      <div class="site__hidden__info">
        <span class="site__hidden__info__text">
          {{ 'site_hidden_in_settings_1' | ppTranslate }}
          <span class="site__hidden__info__text--link" (click)="openUserSettings()">
            {{ 'site_hidden_in_settings_2' | ppTranslate }}
          </span>
        </span>
      </div>
    }
  </div>
</div>

<router-outlet name="full"></router-outlet>
